import React, { Component } from "react";
import styles from './styles.css'

class Title extends Component {
  direction() {
    if(this.props.direction) {
      return this.props.direction
    }

    return '';
  }

  className() {
    return [
      'section-title',
      'is-' + this.direction()
    ].join(' ')
  }

  render() {
    return (
      <h4 className={this.className()}>{this.props.children}</h4>
    )
  }
}

export default Title




// WEBPACK FOOTER //
// ./src/components/Title/index.js